<template>
  <!-- .etl ex-tab-list -->
  <div class="etl">
    <div class="etl-content">
      <template v-if="list.length">
        <List
          v-model="loading"
          :finished="finished"
          @load="onLoad"
          class="my-box"
        >
          <div
            class="item"
            v-for="(item, index) in list"
            :key="'etl-item-' + index"
            @click="LinkProduct(item.id)"
          >
            <div class="item-t">
              <div class="item-t-img">
                <img v-if="item.video && JSON.parse(item.video).url" :src="JSON.parse(item.video).cover" >
                <img v-else :src="item.banner" v-load="'oPro'" />
              </div>
              <div class="item-t-info" v-if="item.categoryEn">
                <p>{{ item.categoryEn }}</p>
              </div>
              <div class="d_tag" v-if="item.view3DUrl">
                <i class="iconfont icon-d"></i>3D
              </div>
              <div class="img-v" v-if="item.panoramaUrl">
                <i class="iconfont icon-VR1"></i>
              </div>
              <div
                class="play_video"
                v-if="item.video && JSON.parse(item.video).url"
              >
                <i class="iconfont icon-zhibo"></i>
              </div>
              <!-- <div class="item-t-type" v-if="item.exhibitor.isLiving">
                <span class="my-brand dot">直播中</span>
              </div> -->
            </div>
            <div class="item-b">
              <div class="txt1">{{ item.name  }}</div>
              <div class="txt2">
                {{
                  item.exhibitor.company&&item.exhibitor.company.nameEn?item.exhibitor.company.nameEn:''
                }}
              </div>
            </div>
          </div>
          <div slot="loading" class="f-tac loading">
            <img src="@assets/img/new/icon-loading.png" />
            loading...
          </div>
          <div slot="finished" class="f-tac loading">It's the end~</div>
        </List>
      </template>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { List } from "vant";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "ex-tab-list",
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      pageIndex: 0,
      pageSize: 20,
      getProductPagedListMatchMemberCategory: {},
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
    }),
  },
  components: {
    List,
  },
  created() {
    this.onLoad();
  },
  methods: {
    ...mapActions({
      LinkProduct: "linkTo/LinkProduct",
      graphqlPostByZXS:'en/graphqlPostByZXS'
    }),
    onLoad() {
      if (this.finished) return;
      this.pageIndex += 1;
      this.getList();
    },
    async getList() {
      let query = `
        query getProductPagedListMatchMemberCategory(
          $inMmeberId: Guid!
          $size: Int
          $page: Int
        ) {
          getProductPagedListMatchMemberCategory(
            inMmeberId: $inMmeberId
            size: $size
            page: $page
          ) {
            hasNextPage
            indexFrom
            pageIndex
            pageSize
            items {
              id
              name
              nameEn
              category
              categoryEn
              banner
              view3DUrl
              panoramaUrl
              video
              exhibitor {
                isLiving
                company {
                  name
                  nameEn
                }
              }
            }
          }
        }
      `;
      let opt={
        query:query,
        variables:{
          page: this.pageIndex,
          size: this.pageSize,
          inMmeberId: this.userInfo.inMember.id,
        }
      }
      let data=await this.graphqlPostByZXS(opt);
      let res = JSON.parse(JSON.stringify(data.data.getProductPagedListMatchMemberCategory));
      if (res && res.items.length) {
        res.items.forEach((e) => {
          // console.log(e,'eee')
          // if(e.category&&e.category.indexOf('{')!=-1){
          //   let cate=JSON.parse(e.category)
          //   e.category=cate.Value
          // }
          if (e.category && e.category.indexOf("[") !== -1) {
            if (Array.isArray(JSON.parse(e.category))) {
              if (JSON.parse(e.category)[0]) {
                e.category = JSON.parse(e.category)[0].Value;
              } else {
                e.category = "";
              }
            } else {
              let cate = JSON.parse(e.category)[0];
              e.category = cate.Value;
            }
          }
          if (e.categoryEn && e.categoryEn.indexOf("[") !== -1) {
            if (Array.isArray(JSON.parse(e.categoryEn))) {
              if (JSON.parse(e.categoryEn)[0]) {
                e.categoryEn = JSON.parse(e.categoryEn)[0].Value;
              } else {
                e.categoryEn = "";
              }
            } else {
              let cate = JSON.parse(e.categoryEn)[0];
              e.categoryEn = cate.Value;
            }
          }
          if (e.banner && e.banner.indexOf("[") != -1) {
            let arr = JSON.parse(e.banner);
            e.banner = arr[0];
          }
        });
      }

      if (this.pageIndex == 1) {
        this.list = res.items;
      } else {
        this.list = [...new Set([...this.list, ...res.items])];
      }
      this.loading = false;
      if (!res.hasNextPage) {
        this.finished = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.etl {
  &-title {
    padding: 0.25rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    color: #333;
    img {
      width: 13px;
    }
    .txt {
      padding: 0 7px;
      font-size: 15px;
      font-weight: bold;
    }
  }
  &-content {
    min-height: 50vh;
    .my-box {
      padding: 15px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .item {
        margin-bottom: 10px;
        width: calc(50% - 6px);
        display: inline-block;
        height: 4.42rem;
        background-color: #fff;
        border-radius: 3px;
        border: solid 1px #dce4ec;
        &-t {
          width: 100%;
          height: 3.35rem;
          position: relative;
          // border-bottom: solid 1px #dce4ec;
          &-img {
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 1;
            img {
              position: absolute;
              z-index: 1;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              margin: auto;
              // object-fit: cover;
              width: 100%;
              height: 100%;
            }
          }
          &-info {
            position: absolute;
            z-index: 2;
            bottom: 0;
            left: 0;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 0 5px;
            background-color: rgba(#000, 0.5);
            color: #fff;
            text-align: right;
            width: 100%;
            p {
              font-size: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .d_tag {
            position: absolute;
            z-index: 1;
            width: 0.8rem;
            height: 0.35rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #ff5c00;
            padding: 0 0.13rem 0 0.05rem;
            box-sizing: border-box;
            border-radius: 0 0 0 0.1rem;
            color: #fff;
            font-size: 0.2rem;
            right: 0;
            top: 0;
            .iconfont {
              font-size: 0.36rem;
            }
          }
          .img-v {
            position: absolute;
            z-index: 1;
            width: 0.38rem;
            height: 0.35rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
            box-sizing: border-box;
            border: 1px solid #0190fe;
            color: #0190fe;
            font-size: 0.2rem;
            left: 0;
            top: 0;
          }
          .play_video {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.2);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 2;
            i {
              font-size: 0.72rem;
              color: #fff;
            }
          }
          &-type {
            position: absolute;
            z-index: 1;
            top: 0.2rem;
            left: 0.2rem;
            .my-brand {
              width: 0.88rem;
              height: 0.3rem;
              display: flex;
              justify-content: center;
              align-items: center;
              background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
                linear-gradient(#000, #000);
              background-blend-mode: normal, normal;
              border-radius: 0.05rem;
              color: #fff;
              font-size: 0.18rem;
              vertical-align: middle;
              margin-left: 0;
              &.dot {
                &::before {
                  content: "";
                  display: block;
                  width: 0.12rem;
                  height: 0.12rem;
                  border-radius: 50%;
                  background-color: #fff;
                  margin-right: 0.06rem;
                }
              }
            }
          }
        }
        &-b {
          padding: 0.12rem 0.2rem;
          .txt1 {
            font-size: 0.26rem;
            color: #333;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-bottom: 0.08rem;
            min-height: 0.3rem;
          }
          .txt2 {
            font-size: 0.22rem;
            color: #666;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  &::v-deep {
    .van-tabs {
      .van-sticky {
        transform: none !important;
      }
      .van-tabs__wrap {
        &::after {
          border-width: 0 0 1px;
        }
      }
    }
    .van-tab {
      color: #666;
      font-size: 13px;
      font-weight: 600;
    }
    .van-tab--active {
      color: #ff5c00;
    }
    .van-list__finished-text,
    .van-list__loading {
      width: 100%;
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>